import { render, staticRenderFns } from "./CardCatalogueCardActions.vue?vue&type=template&id=160a3673&scoped=true"
import script from "./CardCatalogueCardActions.vue?vue&type=script&lang=js"
export * from "./CardCatalogueCardActions.vue?vue&type=script&lang=js"
import style0 from "./CardCatalogueCardActions.vue?vue&type=style&index=0&id=160a3673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a3673",
  null
  
)

export default component.exports